import { SelectOption } from './FormFields'
import { Any } from '@api/orvalFetcher'

function cleanFormData<T extends Record<string, Any>>(data: T): Partial<T> {
  return Object.entries(data).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined) {
      acc[key as keyof T] = value
    }

    return acc
  }, {} as Partial<T>)
}

export function toApiPayload<T extends Record<string, Any>>(
  data: T,
  transformers?: Partial<Record<keyof T, (value: Any) => Any>>,
): Record<string, Any> {
  const cleaned = cleanFormData(data)

  if (!transformers) return cleaned

  return Object.entries(cleaned).reduce(
    (acc, [key, value]) => {
      const transformer = transformers[key as keyof T]
      acc[key] = transformer ? transformer(value) : value

      return acc
    },
    {} as Record<string, Any>,
  )
}

export const normalizeSelectOption = (item: Any): SelectOption => ({
  label: item.label ?? '',
  value: item.value ?? '',
})
